<template>
  <div class="notifications-button-component">
    <VButton
      id="notifications-button"
      theme="link"
      @click="show"
    >
      <template #icon>
        <VIcon
          material="notifications"
          theme="outlined"
        />
      </template>
      Уведомления
    </VButton>

    <VPopup
      ref="popup"
      target="#notifications-button"
      class="notifications-popup"
      position="bottom"
      align="right"
      not-hide-on-click
      :offset="2"
      :visible="visible"
      @mouseleave="hide"
    >
      <header>Уведомления</header>

      <section>
				<VTabs
					theme="compact"
					:tabs="tabs"
					:active-tab="activeTab"
					@update:active-tab="tab => activeTab = tab"
				/>

        <section
          v-if="todayNotifications.length > 0"
          class="notifications"
        >
          <header>Сегодня</header>

          <VNotificationItem
            v-for="(item, index) in todayNotifications"
            :key="'today_' + index"
            :notification="item"
            @update:notification="onNotificationUpdate"
            @delete="onNotificationDelete"
          />
        </section>

        <section
          v-if="olderNotifications.length > 0"
          class="notifications"
        >
          <header class="notifications-header">
            БОЛЕЕ СТАРЫЕ
          </header>

          <VNotificationItem
            v-for="(item, index) in olderNotifications"
            :key="'older_' + index"
            :notification="item"
            @update:notification="onNotificationUpdate"
            @delete="onNotificationDelete"
          />
        </section>

        <section
          v-if="notifications.length === 0"
          class="notifications empty"
        >
          Уведомлений нет
        </section>
      </section>
    </VPopup>
  </div>
</template>

<script>
import VNotificationItem     from './VNotificationItem.vue';
import notificationsTestData from './test-data';
import Utils from "@/core/utils/Utils";

export default {
	name:       'VNotificationsPopup',
	components: {
		VNotificationItem,
	},
	data() {
		const tabs = [
			{
				id:   'all',
				name: 'Все',
			},
			{
				id:   'platform',
				name: 'Платформа',
			},
			{
				id:   'orders',
				name: 'Заказы',
			},
		];
		return {
			tabs,
			activeTab:     tabs[0],
			visible:       false,
			notifications: notificationsTestData,
		};
	},

	computed: {
		todayNotifications() {
			return this.notifications.filter(
				item => item.createdAt > Utils.date.toDayStart(new Date())
			);
		},
		olderNotifications() {
			return this.notifications.filter(
				item => item.createdAt < Utils.date.toDayStart(new Date())
			);
		},
	},

	methods: {
		show() {
			this.visible = true;
		},
		hide(event) {
			if (!this.visible) return;
			const x            = event.clientX || event.pageX;
			const y            = event.clientY || event.pageY;
			const hoverElement = document.elementFromPoint(x, y);
			if (!this.$el.contains(hoverElement) && !this.$refs.popup.$el.contains(hoverElement)) {
				this.visible = false;
			}
		},
		onNotificationUpdate(notification) {
			const notifications = [...this.notifications];
			const index         = notifications.findIndex(item => item.id === notification.id);
			if (index > -1) {
				notifications[index] = notification;
			}
			this.notifications = notifications;
		},
		onNotificationDelete(notification) {
			const notifications = [...this.notifications];
			const index         = notifications.findIndex(item => item.id === notification.id);
			if (index > -1) {
				notifications.splice(index, 1);
			}
			this.notifications = notifications;
		},
	},
};
</script>

<style lang="scss" src="./VNotificationsPopup.scss"/>
